// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3310) return "static/chunks/3310-ff94e62183aa5f30.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5568":"904bb7f8e8b362d6","6324":"dc7f9ffe281b6a34"}[chunkId] + ".js";
};